import { APP_NAME, $document } from '../utils/environment';
import { module } from 'modujs';

const MODULE_NAME = 'Giftcard';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {
        this.amount = 20;
        this.quantity = 1;
        this.el.querySelector('.js-amount').$on('change',(el) => {this.amount = parseInt(this.el.querySelector('.js-amount').value);})
        this.el.querySelector('.js-qty').$on('change',(el) => {this.quantity = parseInt(this.el.querySelector('.js-qty').value,10);})
        this.el.$on('submit',(e) => {this.submit(e);})
    }

    submit(e) {
        e.preventDefault();

        Snipcart.api.cart.items.add({
            id: 'CC|'+this.amount,
            name: 'Carte cadeau de '+this.amount+'$',
            price: this.amount,
            taxable: false,
            url: '/',
            image: 'https://www.randolph.ca/app/uploads/2022/03/carte-cadeau.png',/*CHANGE */
            quantity: this.quantity,
            metadata: {in_stock: true, is_giftcard: true}
        });
    }

    destroy() {
        super.destroy()
    }
}
